import { makeStyles } from '@material-ui/core/styles';

const usePartnerOnlySwitchFilterStyles = makeStyles(
  (muiTheme) => ({
    root: {
      backgroundColor: 'white',
      padding: muiTheme.spacing(1.2, 2),
      margin: muiTheme.spacing(0, -2),
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    switch: {
      marginRight: muiTheme.spacing(-0.5),
    },
  }),
  { name: 'PartnerOnlySwitchFilter' },
);

export default usePartnerOnlySwitchFilterStyles;
